/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Injector} from '@angular/core';
/**
 * Custom injector to be used when providing custom
 * injection tokens to components inside a portal.
 * \@docs-private
 */
export class PortalInjector implements Injector {
/**
 * @param {?} _parentInjector
 * @param {?} _customTokens
 */
constructor(
private _parentInjector: Injector,
private _customTokens: WeakMap<any, any>) { }
/**
 * @param {?} token
 * @param {?=} notFoundValue
 * @return {?}
 */
get(token: any, notFoundValue?: any): any {
    const /** @type {?} */ value = this._customTokens.get(token);

    if (typeof value !== 'undefined') {
      return value;
    }

    return this._parentInjector.get<any>(token, notFoundValue);
  }
}

function PortalInjector_tsickle_Closure_declarations() {
/** @type {?} */
PortalInjector.prototype._parentInjector;
/** @type {?} */
PortalInjector.prototype._customTokens;
}

